import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DynamicFormConfigComponent } from './dynamic-form-config.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputModule } from 'src/app/ui/input/input.module';
import { SelectModule } from 'src/app/ui/select/select.module';
import { CheckboxModule } from 'src/app/ui/checkbox/checkbox.module';
import { RadioModule } from 'src/app/ui/radio/radio.module';
import { CardModule } from 'src/app/ui/card/card.module';
import { IconModule } from 'src/app/ui/icon/icon.module';
import { ModalModule } from 'src/app/ui/modal/modal.module';
import { CollapseModule } from 'src/app/ui/collapse/collapse.module';
import { DynamicFormConfigHeaderComponent } from './dynamic-form-config-header/dynamic-form-config-header.component';
import { DynamicFormConfigEditorComponent } from './dynamic-form-config-editor/dynamic-form-config-editor.component';


@NgModule({
  declarations: [
    DynamicFormConfigComponent,
    DynamicFormConfigHeaderComponent,
    DynamicFormConfigEditorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    InputModule,
    SelectModule,
    CheckboxModule,
    RadioModule,
    CardModule,
    IconModule,
    ModalModule,
    CollapseModule
  ],
  exports: [
    DynamicFormConfigComponent
  ]
})
export class DynamicFormConfigModule { }
